import { all, fork } from 'redux-saga/effects'

import { watchHandleDeepLinking } from './App'
import {
    watchIsSpeaking,
    watchHandleLocalDominantSpeaker,
    watchHandlePIP,
    watchHandleRoomState,
    watchHandleFullScreenToggle,
} from './Room'
import { watchReceiveNoteMessage, watchSendSocketMessage } from './WebSocket'

const sagas = [
    fork(watchHandleDeepLinking),
    fork(watchIsSpeaking),
    fork(watchHandleLocalDominantSpeaker),
    fork(watchHandlePIP),
    fork(watchReceiveNoteMessage),
    fork(watchHandleRoomState),
    fork(watchHandleFullScreenToggle),
    fork(watchSendSocketMessage),
]

export default function* rootSaga() {
    yield all(sagas)
}
